import {
	SESSION_FETCH,
	SESSION_FETCH_SUCCESS,
	SESSION_FETCH_FAIL,
	VERIFY_ACCOUNT_FETCH,
	VERIFY_ACCOUNT_FETCH_SUCCESS,
	VERIFY_ACCOUNT_FETCH_FAIL,
	USER_SETTING_WRITE,
	USER_SETTING_WRITE_SUCCESS,
	USER_SETTING_WRITE_FAIL,
	USER_UPDATE_SUCCESS,
} from './actions';
import { setKey } from '../../storage';
import { XC_URL, CAP_KEY, ONBOARDING_KEY } from 'config';
import { extractPropsforSuperagentHttpError } from '../../errors/errorhelper';
import ERRORS from '../../errors/errorids';
import AppError from '../../errors/apperror';
import HttpError from '../../errors/httperror';

const initialState = {
	loading: false,
	error: false,
	id: null,
	user: null
};

export default (state = initialState, action) => {
	switch (action.type) {

		case SESSION_FETCH:
		case USER_SETTING_WRITE:
			return {
				...state,
				loading: true
			};

		case SESSION_FETCH_SUCCESS: {
			setKey(action.result.user.id);
			return {
				...state,
				loading: false,
				id: action.result.id,
				user: {
					...action.result.user,
				},
			};
		}

		case USER_UPDATE_SUCCESS: {
			const { firstName, lastName, name, hasPassword } = action.payload;
			return {
				...state,
				loading: false,
				user: {
					...state.user,
					firstName,
					lastName,
					name,
					hasPassword
				},
			};
		}

		case SESSION_FETCH_FAIL:
			return {
				...state,
				loading: false,
				error: true,
				id: null,
				user: null
			};

		case USER_SETTING_WRITE_SUCCESS:
			return {
				...state,
				user: {
					...state.user,
					settings: action.payload
				}
			};

		case USER_SETTING_WRITE_FAIL:
			return {
				...state,
				loading: false,
				error: true
			};

		default:
			return state;
	}
};

export const fetchSession = () => {
	return {
		types: [SESSION_FETCH, SESSION_FETCH_SUCCESS, SESSION_FETCH_FAIL],
		promise: client => client.get('/session').catch((error) => {

			const httpErrorProps = extractPropsforSuperagentHttpError(error);

			const nError = new AppError({
				message: 'session.fetchSession() failed',
				errorId: ERRORS.UNKNOWN,
				originalError: new HttpError(httpErrorProps),
				visualisers: { feature: 'REDUX_SESSION' }
			});

			throw nError;
		})
	};
};

export const verifyUserAccount = () => {
	const host = XC_URL.slice(-1) === '/' ? XC_URL.slice(0, -1) : XC_URL; // remove trailing slash
	return {
		types: [VERIFY_ACCOUNT_FETCH, VERIFY_ACCOUNT_FETCH_SUCCESS, VERIFY_ACCOUNT_FETCH_FAIL],
		promise: client => client.get('/xara-basic/confirmation', {
			params: { host }
		})
			.catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);

				const nError = new AppError({
					message: 'session.verifyUserAccount() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_SESSION' }
				});

				throw nError;
			})
	};
};

/**
 * Dispatches a redux action with a promise that will write the user settings to the middleware
 *
 * @param {Function} dispatch provided by Redux' mapDispatchToProps
 * @param {Object} settings the new user settings to be stored on the middleware
 */
const dispatchWriteSettings = (dispatch, settings) => {
	return dispatch({
		types: [USER_SETTING_WRITE, USER_SETTING_WRITE_SUCCESS, USER_SETTING_WRITE_FAIL],
		payload: settings,
		promise: client => client.patch('/settings', { data: { settings } }).catch((error) => {
			const httpErrorProps = extractPropsforSuperagentHttpError(error);

			const nError = new AppError({
				message: 'session.dispatchWriteSettings() failed',
				errorId: ERRORS.UNKNOWN,
				originalError: new HttpError(httpErrorProps),
				visualisers: { feature: 'REDUX_SESSION' }
			});

			throw nError;
		})
	});
};

/**
 * Writes the provided settings to the user settings object on the middleware, under the CAP_KEY property.
 * @param {Object} newSettings to be recursively merged onto the old ones
 */
export const writeUserSettings = (newSettings) => {
	return (dispatch) => {
		return dispatchWriteSettings(dispatch, { [CAP_KEY]: newSettings });
	};
};

/**
 * Resets the existing onboarding settings, by writing the provided object at the CAP_KEY.ONBOARDING_KEY path.
 * @param {Object} newOnboardingSettings to overwrite the previous ones
 */
export const resetOnBoardingSettings = (newOnboardingSettings) => {
	return (dispatch, getState) => {
		return dispatchWriteSettings(dispatch, { [`${CAP_KEY}.${ONBOARDING_KEY}`]: newOnboardingSettings });
	};

};



// WEBPACK FOOTER //
// ./src/redux/modules/session.js